class ShippingsListCtrl {

    constructor(Shippings, $state, $injector, $rootScope) {
        this.store = Shippings;
        this.state = $state;
        this.injector = $injector;

        this.acl = this.injector.get('Acl');
        this.navService = this.injector.get('NavService');
        this.rootScope = $rootScope
    }

    showDetails(payload) {
        return this.state.go('app.shippings.details', {sid: payload.row.id});
    }

    $onInit() {
        this.store.dispatch('loadWorkflows', 'shipping::list');
        this.store.commit('setVm', this);
    }
}

ShippingsListCtrl.$inject = [
    'Shippings',
    '$state',
    '$injector',
    '$rootScope'
];

angular
    .module('festzelt-os.shippings')
    .controller('ShippingsListCtrl', ShippingsListCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/shippings/controllers/list-controller.js